/* HARDSEN : panier comme Northson, sans appli (scripts/montage/panier_code.py, 05/10).
   - <hs-minuteur>       5:00 qui descend, gardé dans sessionStorage, démarre à la première ouverture du tiroir ;
                          à zéro, un autre message ; ne vide jamais le panier, aucune autre conséquence.
   - <hs-paire-en-plus>  ajoute la paire choisie (taille, couleur) par /cart/add.js puis rafraîchit le panier.
   - <hs-panier-garde>   rendu par le thème quand le panier a une paire en plus sans le produit principal :
                          la retire (pas de paire à 9,99 € seule) puis rafraîchit le panier.
   Rafraîchir = tiroir, pastille du panier et, sur la page /cart, ses deux sections. */
(function () {
  if (window.HSPanier) return;

  var CLE_FIN = 'hs-minuteur-fin';
  var DUREE = 5 * 60 * 1000;
  var finMemoire = 0;

  function routes() {
    var r = window.routes || {};
    return {
      panier: r.cart_url || '/cart',
      ajout: (r.cart_add_url || '/cart/add') + '.js',
      maj: (r.cart_update_url || '/cart/update') + '.js',
    };
  }

  function lire(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function remplacer(cible, html, selecteur) {
    if (!cible || !html) return;
    var source = lire(html).querySelector(selecteur);
    if (source) cible.innerHTML = source.innerHTML;
  }

  function rafraichir() {
    var r = routes();
    var tiroir = document.querySelector('cart-drawer');
    var lignesPage = document.getElementById('main-cart-items');
    var piedPage = document.getElementById('main-cart-footer');
    var ids = ['cart-icon-bubble'];
    if (tiroir) ids.push('cart-drawer');
    if (lignesPage && lignesPage.dataset.id) ids.push(lignesPage.dataset.id);
    if (piedPage && piedPage.dataset.id) ids.push(piedPage.dataset.id);

    return Promise.all([
      fetch(r.panier + '.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }),
      fetch(r.panier + '?sections=' + ids.join(',')).then(function (x) { return x.json(); }),
    ]).then(function (res) {
      var panier = res[0];
      var sections = res[1] || {};
      var vide = panier.item_count === 0;

      if (tiroir && sections['cart-drawer']) {
        remplacer(tiroir.querySelector('#CartDrawer'), sections['cart-drawer'], '#CartDrawer');
        tiroir.classList.toggle('is-empty', vide);
        var voile = tiroir.querySelector('#CartDrawer-Overlay');
        if (voile) voile.addEventListener('click', function () { tiroir.close(); });
      }
      remplacer(document.getElementById('cart-icon-bubble'), sections['cart-icon-bubble'], '.shopify-section');
      if (lignesPage && sections[lignesPage.dataset.id]) {
        remplacer(lignesPage.querySelector('.js-contents'), sections[lignesPage.dataset.id], '.js-contents');
        var blocLignes = document.querySelector('cart-items');
        if (blocLignes) blocLignes.classList.toggle('is-empty', vide);
      }
      if (piedPage && sections[piedPage.dataset.id]) {
        remplacer(piedPage.querySelector('.js-contents'), sections[piedPage.dataset.id], '.js-contents');
        piedPage.classList.toggle('is-empty', vide);
      }
      return panier;
    });
  }

  window.HSPanier = { rafraichir: rafraichir };

  /* ---------------------------------------------------------------- minuteur */
  function lireFin() {
    try {
      return parseInt(window.sessionStorage.getItem(CLE_FIN) || '0', 10) || finMemoire;
    } catch (e) {
      return finMemoire;
    }
  }

  function ecrireFin(fin) {
    finMemoire = fin;
    try {
      window.sessionStorage.setItem(CLE_FIN, String(fin));
    } catch (e) {}
  }

  function deuxChiffres(n) {
    return (n < 10 ? '0' : '') + n;
  }

  if (!customElements.get('hs-minuteur')) {
    customElements.define(
      'hs-minuteur',
      class extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.tic();
          this.intervalle = setInterval(function () { self.tic(); }, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.intervalle);
        }

        tic() {
          var fin = lireFin();
          if (!fin) {
            var tiroir = this.closest('cart-drawer');
            if (tiroir && !tiroir.classList.contains('active')) {
              this.afficher(DUREE);
              return;
            }
            fin = Date.now() + DUREE;
            ecrireFin(fin);
          }
          if (fin - Date.now() <= 0) {
            // Arrivé à 0 : le compte à rebours repart pour 5:00 (retour de Pablo du 05/10, on ne le voyait plus).
            fin = Date.now() + DUREE;
            ecrireFin(fin);
          }
          this.afficher(fin - Date.now());
        }

        afficher(ms) {
          var temps = this.querySelector('[data-hs-temps]');
          var enCours = this.querySelector('[data-hs-en-cours]');
          var fini = this.querySelector('[data-hs-fini]');
          if (ms <= 0) {
            if (enCours) enCours.hidden = true;
            if (fini) fini.hidden = false;
            clearInterval(this.intervalle);
            return;
          }
          var s = Math.ceil(ms / 1000);
          if (temps) temps.textContent = deuxChiffres(Math.floor(s / 60)) + ':' + deuxChiffres(s % 60);
          if (enCours) enCours.hidden = false;
          if (fini) fini.hidden = true;
        }
      }
    );
  }

  /* ---------------------------------------------------------------- paire en plus */
  if (!customElements.get('hs-paire-en-plus')) {
    customElements.define(
      'hs-paire-en-plus',
      class extends HTMLElement {
        connectedCallback() {
          if (this.pret) return;
          this.pret = true;
          var self = this;
          try {
            this.variantes = JSON.parse(this.querySelector('[data-hs-variantes]').textContent);
          } catch (e) {
            this.variantes = [];
          }
          // Le code de Dawn écoute « change » sur tout le panier (quantités) : les menus taille / couleur ne doivent
          // pas lui parvenir.
          this.addEventListener('change', function (e) { e.stopPropagation(); });
          var bouton = this.querySelector('[data-hs-ajouter]');
          if (bouton) {
            bouton.addEventListener('click', function (e) {
              e.preventDefault();
              self.ajouter(bouton);
            });
          }
        }

        variante() {
          var choix = Array.prototype.map.call(this.querySelectorAll('select[data-hs-option]'), function (s) {
            return s.value;
          });
          for (var i = 0; i < this.variantes.length; i++) {
            var v = this.variantes[i];
            var ok = v.o.length === choix.length;
            for (var j = 0; ok && j < choix.length; j++) ok = v.o[j] === choix[j];
            if (ok) return v;
          }
          return null;
        }

        ajouter(bouton) {
          var self = this;
          var erreur = this.querySelector('.hs-paire__erreur');
          var v = this.variante();
          if (!v || v.d === false) {
            if (erreur) {
              erreur.textContent = 'Cette taille n’est plus disponible.';
              erreur.hidden = false;
            }
            return;
          }
          bouton.disabled = true;
          bouton.setAttribute('aria-busy', 'true');
          if (erreur) erreur.hidden = true;
          fetch(routes().ajout, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
          })
            .then(function (x) {
              if (!x.ok) throw new Error('ajout');
              return rafraichir();
            })
            .catch(function () {
              bouton.disabled = false;
              bouton.removeAttribute('aria-busy');
              if (erreur && self.isConnected) {
                erreur.textContent = 'Ajout impossible pour le moment. Réessayez.';
                erreur.hidden = false;
              }
            });
        }
      }
    );
  }

  /* ---------------------------------------------------------------- garde */
  var gardeEnCours = false;
  if (!customElements.get('hs-panier-garde')) {
    customElements.define(
      'hs-panier-garde',
      class extends HTMLElement {
        connectedCallback() {
          if (gardeEnCours) return;
          var cles = (this.dataset.cles || '').split(',').filter(Boolean);
          if (!cles.length) return;
          gardeEnCours = true;
          var maj = {};
          cles.forEach(function (k) { maj[k] = 0; });
          fetch(routes().maj, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: maj }),
          })
            .then(function () { return rafraichir(); })
            .catch(function () {})
            .then(function () { gardeEnCours = false; });
        }
      }
    );
  }
})();
